import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './AdditionalInfoWidget.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import HintBox from '../../../../../../../moreCore/UI/HintBox/HintBox';
import DateInput from '../../../../../../../moreCore/UI/DateInput/DateInput';
import Edit from '../../../../../../../moreCore/UI/Edit/Edit';
import { AdditionalInfoWidgetSaveData, TravelBookingLoadData, VT_Travel_Types } from "../../../../TravelBookingListTypes";
import SearchSelect from '../../../../../../../moreCore/UI/SearchSelect/SearchSelect';
import _GlobalSelectEntityDialogsMixin from '../../../../../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import lang from 'dojo/_base/lang';

class AdditionalInfoWidget extends compose(_WidgetBaseSP, _GlobalSelectEntityDialogsMixin) {

    templateString: any = template;

    private projectId: string;
    private entity: TravelBookingLoadData;
    private bookingType: VT_Travel_Types;

    private responsibleInput: MdsLax<InstanceType<typeof HintBox>>;
    private reminderOnInput: MdsLax<InstanceType<typeof DateInput>>;
    private noteExternalInput: MdsLax<InstanceType<typeof Edit>>;
    private noteInternalInput: MdsLax<InstanceType<typeof Edit>>;
    private bookingNoInput: MdsLax<InstanceType<typeof Edit>>;
    private searchselectBookingCollection: MdsLax<InstanceType<typeof SearchSelect>>;

    constructor(bookingType: VT_Travel_Types, projectId: string) {
        super(...(arguments as unknown as []));
        this.bookingType = bookingType;
        this.projectId = projectId;
    }

    onInputChange(e): void {
        this.emit("change");
    }

    getData(): AdditionalInfoWidgetSaveData {
        var formData: AdditionalInfoWidgetSaveData = {
            responsibleId: this.responsibleInput.getValue("value"),
            note: this.noteExternalInput.getValue(),
            note_internal_use: this.noteInternalInput.getValue(),
            bookingCollectorId: this.searchselectBookingCollection.getValue(),
        };
        
        //if (this.bookingType !== "travel_info_booking") {
        //    formData.date_reminder = this.dateToLocalISOString(this.reminderOnInput.getValue());
        //}

        return formData;
    }

    prepareData(entity?: TravelBookingLoadData): void {
        if (entity) {
            this.setEntity(entity);
        } else {
            this.responsibleInput.setValue(null, true);
            this.noteExternalInput.setValue("", true);
            this.noteInternalInput.setValue("", true);
            this.searchselectBookingCollection.setValue(null, true);

            if (this.bookingType !== "travel_info_booking") {
                this.reminderOnInput.setValue(null, true);
            }
        }
    }


    private setEntity(entity: TravelBookingLoadData): void {
        this.entity = entity;
        this.responsibleInput.setValue(entity.ref_responsible, true);
        this.noteExternalInput.setValue(entity.note, true);
        this.noteInternalInput.setValue(entity.note_internal_use, true);
        this.searchselectBookingCollection.setValue(entity.ref_travel_booking_collector, true);
        //if (this.bookingType !== "travel_info_booking") {
        //    this.reminderOnInput.setValue(entity.date_reminder, true);
        //}
    }

    private _onClickOpenAddressSED(mode: string, e: MouseEvent): void {

        this.loadSelectEntityDialog(e,
            mode,
            lang.hitch(this, this._onCallbackSED),
        );
    }

    private _onCallbackSED(mode: string, data, items): void {
        items?.forEach((element) => {
            switch (mode) {
                case "responsible":
                    this.responsibleInput.setValue(element.entry.data);
                    break;
            }
        });
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        switch (this.bookingType) {
            case "travel_info_booking":
                this.hideNode(this.reminderOnInput, true);
        }

        this.noteExternalInput.setIsMultiline(true, 4);
        this.noteInternalInput.setIsMultiline(true, 4);

        this.searchselectBookingCollection.addAdditionalRequestParameter("projectId", this.projectId);
        this.searchselectBookingCollection.loadListValues(null, true);

        if (this.bookingType === "transport_booking" || this.bookingType === "travel_info_booking") {
            this.hideNode(this.searchselectBookingCollection.domNode, true);
        }

        this.SEDconfigCallfunction = "Webtool_API__TravelBookingForm_SED_GetConfig";
        this.responsibleInput.addInlineButton(lang.hitch(this, this._onClickOpenAddressSED, "responsible"));

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(AdditionalInfoWidget);